import {
  AppAction,
  GetPartitionsAction,
  GetPartitionsSuccessAction,
  GetDimensionsAction,
  GetDimensionsSuccessAction,
  GetOptionsAction,
  GetOptionsSuccessAction,
  GeDataDrivenFiltersErrorAction,
  AddUpdateOrRemoveDataDrivenFilterAction,
  AddUpdateOrRemoveDataDrivenFiltersPartitionAction,
  InitDataDrivenFiltersAction,
  UpdateOptionAction,
} from 'types';

export const INIT_DATADRIVEN_FILTERS = 'filter-bar/data-driven-filters/init';
export const FETCH_DATADRIVEN_FILTERS_PARTITIONS =
  'filter-bar/data-driven-filters/fetch-partitions';
export const FETCH_DATADRIVEN_FILTERS_PARTITIONS_SUCCESS =
  'filter-bar/data-driven-filters/fetch-partitions/success';
export const FETCH_DATADRIVEN_FILTERS_PARTITIONS_ERROR =
  'filter-bar/data-driven-filters/fetch-partitions/error';
export const FETCH_DATADRIVEN_FILTERS_DIMENSIONS =
  'filter-bar/data-driven-filters/fetch-dimensions';
export const FETCH_DATADRIVEN_FILTERS_DIMENSIONS_SUCCESS =
  'filter-bar/data-driven-filters/fetch-dimensions/success';
export const FETCH_DATADRIVEN_FILTERS_DIMENSIONS_ERROR =
  'filter-bar/data-driven-filters/fetch-dimensions/error';
export const FETCH_DATADRIVEN_FILTERS_OPTIONS =
  'filter-bar/data-driven-filters/fetch-options';
export const FETCH_DATADRIVEN_FILTERS_OPTIONS_SUCCESS =
  'filter-bar/data-driven-filters/fetch-options/success';
export const FETCH_DATADRIVEN_FILTERS_OPTIONS_ERROR =
  'filter-bar/data-driven-filters/fetch-options/error';

export const ADD_ENTERPRISE_FILTER =
  'filter-bar/data-driven-filters/add-filter';
export const REMOVE_ENTERPRISE_FILTER =
  'filter-bar/data-driven-filters/remove-filter';
export const UPDATE_ENTERPRISE_FILTER =
  'filter-bar/data-driven-filters/update-filter';
export const ADD_PARTITION = 'filter-bar/data-driven-filters/add-partition';
export const UPATE_PARTITION =
  'filter-bar/data-driven-filters/update-partition';
export const REMOVE_PARTITION =
  'filter-bar/data-driven-filters/remove-partition';

export const UPDATE_ENTERPRISE_FILTER_OPTION =
  'filter-bar/data-driven-filters/update-option';

export type InitDataDrivenFiltersAppAction =
  AppAction<InitDataDrivenFiltersAction>;

export const initDataDrivenFilters = (params: InitDataDrivenFiltersAction) => ({
  type: INIT_DATADRIVEN_FILTERS,
  ...params,
});

export type AddDataDrivenFilterAction =
  AppAction<AddUpdateOrRemoveDataDrivenFilterAction>;

export const addDataDrivenFilter = (
  params: AddUpdateOrRemoveDataDrivenFilterAction
) => ({
  type: ADD_ENTERPRISE_FILTER,
  ...params,
});

export type RemoveDataDrivenFilterAction =
  AppAction<AddUpdateOrRemoveDataDrivenFilterAction>;

export const removeDataDrivenFilter = (
  params: AddUpdateOrRemoveDataDrivenFilterAction
) => ({
  type: REMOVE_ENTERPRISE_FILTER,
  ...params,
});

export type UpdateDataDrivenFilterAction =
  AppAction<AddUpdateOrRemoveDataDrivenFilterAction>;

export const updateDataDrivenFilter = (
  params: AddUpdateOrRemoveDataDrivenFilterAction
) => ({
  type: UPDATE_ENTERPRISE_FILTER,
  ...params,
});

export type AddPartitionAction =
  AppAction<AddUpdateOrRemoveDataDrivenFiltersPartitionAction>;

export const addPartition = (
  params: AddUpdateOrRemoveDataDrivenFiltersPartitionAction
) => ({
  type: ADD_PARTITION,
  ...params,
});

export type UpdatePartitionAction =
  AppAction<AddUpdateOrRemoveDataDrivenFiltersPartitionAction>;

export const updatePartition = (
  params: AddUpdateOrRemoveDataDrivenFiltersPartitionAction
) => ({
  type: UPATE_PARTITION,
  ...params,
});

export type RemovePartitionAction =
  AppAction<AddUpdateOrRemoveDataDrivenFiltersPartitionAction>;

export const removePartition = (
  params: AddUpdateOrRemoveDataDrivenFiltersPartitionAction
) => ({
  type: REMOVE_PARTITION,
  ...params,
});

export type FetchPartitionsAction = AppAction<GetPartitionsAction>;

export const fetchDataDrivenFiltersPartitions = (
  params: GetPartitionsAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_PARTITIONS,
  ...params,
});

export type FetchPartitionsSuccessAction =
  AppAction<GetPartitionsSuccessAction>;

export const fetchDataDrivenFiltersPartitionsSuccess = (
  params: GetPartitionsSuccessAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_PARTITIONS_SUCCESS,
  ...params,
});

export type FetchPartitionsErrorAction =
  AppAction<GeDataDrivenFiltersErrorAction>;

export const fetchDataDrivenFiltersPartitionsError = (
  params: GeDataDrivenFiltersErrorAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_PARTITIONS_ERROR,
  ...params,
});

export type FetchDimensionsAction = AppAction<
  GetDimensionsAction & {
    selectedPartitionIndex: number;
  }
>;

export const fetchDataDrivenFiltersDimensions = (
  params: GetDimensionsAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_DIMENSIONS,
  ...params,
});

export type FetchDimensionsSuccessAction =
  AppAction<GetDimensionsSuccessAction>;
export const fetchDataDrivenFiltersDimensionsSuccess = (
  params: GetDimensionsSuccessAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_DIMENSIONS_SUCCESS,
  ...params,
});

export type FetchDimensionsErrorAction =
  AppAction<GeDataDrivenFiltersErrorAction>;
export const fetchDataDrivenFiltersDimensionsError = (
  params: GeDataDrivenFiltersErrorAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_DIMENSIONS_ERROR,
  ...params,
});

export type FetchOptionsAction = AppAction<GetOptionsAction>;

export const fetchDataDrivenFiltersOptions = (params: GetOptionsAction) => ({
  type: FETCH_DATADRIVEN_FILTERS_OPTIONS,
  ...params,
});

export type FetchOptionsSuccessAction = AppAction<GetOptionsSuccessAction>;

export const fetchDataDrivenFiltersOptionsSuccess = (
  params: GetOptionsSuccessAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_OPTIONS_SUCCESS,
  ...params,
});

export type FetchOptionsErrorAction = AppAction<GeDataDrivenFiltersErrorAction>;
export const fetchDataDrivenFiltersOptionsError = (
  params: GeDataDrivenFiltersErrorAction
) => ({
  type: FETCH_DATADRIVEN_FILTERS_OPTIONS_ERROR,
  ...params,
});

export type UpdateOptionActionAppAction = AppAction<UpdateOptionAction>;

export const updateDataDrivenFiltersOption = (params: UpdateOptionAction) => ({
  type: UPDATE_ENTERPRISE_FILTER_OPTION,
  ...params,
});
